// Space Supremacy audio — synthesized SFX (no asset files) + BGM loop.
// Global mute persisted in localStorage. Import the singleton `sfx`.
const KEY = "space_muted_v1";
let _ctx = null;
const ctx = () => {
  if (!_ctx) { const AC = window.AudioContext || window.webkitAudioContext; if (AC) _ctx = new AC(); }
  if (_ctx && _ctx.state === "suspended") _ctx.resume().catch(() => {});
  return _ctx;
};

class Sfx {
  constructor() { this.muted = localStorage.getItem(KEY) === "1"; this.bgm = null; this._bgmSrc = null; }
  isMuted() { return this.muted; }
  toggle() {
    this.muted = !this.muted;
    localStorage.setItem(KEY, this.muted ? "1" : "0");
    if (this.bgm) this.bgm.muted = this.muted;
    if (!this.muted && this.bgm && this.bgm.paused) this.bgm.play().catch(() => {});
    return this.muted;
  }
  _blip(freq, dur = 0.12, type = "square", gain = 0.14) {
    if (this.muted) return;
    const c = ctx(); if (!c) return;
    const o = c.createOscillator(), g = c.createGain();
    o.type = type; o.frequency.value = freq;
    o.connect(g); g.connect(c.destination);
    const t = c.currentTime;
    g.gain.setValueAtTime(gain, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.start(t); o.stop(t + dur);
  }
  hit() { this._blip(180, 0.09, "square", 0.1); }
  crit() { this._blip(90, 0.16, "sawtooth", 0.16); }
  heal() { this._blip(660, 0.18, "sine", 0.12); setTimeout(() => this._blip(880, 0.14, "sine", 0.1), 70); }
  cast() { this._blip(420, 0.08, "triangle", 0.1); }
  victory() { [523, 659, 784, 1046].forEach((f, i) => setTimeout(() => this._blip(f, 0.22, "triangle", 0.14), i * 130)); }
  defeat() { [392, 311, 233].forEach((f, i) => setTimeout(() => this._blip(f, 0.3, "sawtooth", 0.14), i * 160)); }

  startBgm(url) {
    if (!url || (this.bgm && this._bgmSrc === url)) { if (this.bgm && !this.muted) this.bgm.play().catch(() => {}); return; }
    if (this.bgm) { this.bgm.pause(); this.bgm = null; }
    const a = new Audio(url);
    a.loop = true; a.volume = 0.35; a.muted = this.muted;
    this.bgm = a; this._bgmSrc = url;
    a.play().catch(() => {}); // may need a user gesture; resumes on first tap
  }
  stopBgm() { if (this.bgm) { this.bgm.pause(); this.bgm = null; this._bgmSrc = null; } }
}
export const sfx = new Sfx();
